import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { IBloodProductAdministrationState } from '../store/bloodProductAdministration.types'
import { getBloodProductAdministrationSelector } from '../selectors/bloodProductAdministration.selector'
import { saveBloodProductAdministration } from '../store/bloodProductAdministration.actions'
import { BloodProductAdministrationConstants } from '../store/bloodProductAdministration.constants'

export function* setComments() {
  const bloodProductAdministrationState: IBloodProductAdministrationState = yield select(
    getBloodProductAdministrationSelector
  )
  const { comments } = bloodProductAdministrationState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (
        pcrDoc.patient?.bloodProductAdministrationStateList &&
        pcrDoc.patient?.bloodProductAdministrationStateList.length
      ) {
        const index = pcrDoc.patient?.bloodProductAdministrationStateList?.findIndex(
          (imgUltrasound) => imgUltrasound.key === bloodProductAdministrationState.key
        )
        if (index !== -1) {
          if (pcrDoc.patient.bloodProductAdministrationStateList[index].comments !== comments) {
            yield put(saveBloodProductAdministration())
          }
        }
      } else {
        yield put(saveBloodProductAdministration())
      }
    } catch (e) {
      yield put(throwPcrException(`setComments() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([BloodProductAdministrationConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
